(() => {
  if (customElements.get('tk-tpi-promotion')) return;
  const START = Date.parse('2026-10-01T00:00:00+01:00');
  const END = Date.parse('2027-01-01T00:00:00+00:00');
  class TpiPromotion extends HTMLElement {
    connectedCallback() {
      this.refresh = () => {
        const now = Date.now();
        this.hidden = !(this.dataset.preview === 'true' || (now >= START && now < END));
        clearTimeout(this.timer);
        const next = now < START ? START : now < END ? END : null;
        if (next !== null) this.timer = setTimeout(this.refresh, Math.min(next - now + 5, 3600000));
      };
      this.refresh();
      document.addEventListener('visibilitychange', this.refresh);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
    }
  }
  customElements.define('tk-tpi-promotion', TpiPromotion);
})();
